<template>
  <div class="bad-wrap">
    <div class="bad-topbar">
      <button class="bad-back-btn" @click="router.push({ name: 'BookingHome' })">
        ← 返回預約首頁
      </button>
    </div>

    <div v-if="loading" class="bad-state">載入中…</div>
    <div v-else-if="!announcement" class="bad-state">找不到此公告</div>

    <div v-else class="bad-card">
      <div class="bad-meta">
        <span class="bad-badge">公告</span>
        <span class="bad-date">{{ formatDate(announcement.created_at) }}</span>
      </div>
      <h1 class="bad-title">{{ announcement.title }}</h1>
      <div class="bad-content">{{ announcement.content }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import axios from 'axios'

const route = useRoute()
const router = useRouter()
const announcement = ref(null)
const loading = ref(false)

function formatDate(dateStr) {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString('zh-TW', {
    timeZone: 'Asia/Taipei',
    year: 'numeric', month: '2-digit', day: '2-digit'
  })
}

onMounted(async () => {
  loading.value = true
  try {
    const { data } = await axios.get('/api/booking/announcements/active?frontend=1')
    const list = data.announcements || []
    const id = Number(route.params.id)
    announcement.value = list.find(a => a.id === id) || null
  } catch (_) { /* 靜默忽略 */ } finally {
    loading.value = false
  }
})
</script>

<style scoped>
.bad-wrap {
  max-width: 760px;
  margin: 0 auto;
  padding: 24px 16px 64px;
}

.bad-topbar {
  margin-bottom: 24px;
}

.bad-back-btn {
  display: inline-flex;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 0.9rem;
  color: #8b6f5c;
  font-weight: 600;
  padding: 0;
  transition: opacity 0.15s;
}
.bad-back-btn:hover { opacity: 0.7; }

.bad-state {
  color: #aaa;
  font-size: 0.95rem;
  padding: 48px 0;
  text-align: center;
}

.bad-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
  padding: 28px 32px;
}

.bad-meta {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 14px;
}

.bad-badge {
  font-size: 0.72rem;
  font-weight: 700;
  padding: 3px 9px;
  border-radius: 20px;
  background: #f59e0b;
  color: #fff;
  letter-spacing: 0.03em;
}

.bad-date {
  font-size: 0.82rem;
  color: #aaa;
}

.bad-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 20px;
  line-height: 1.5;
}

.bad-content {
  font-size: 0.93rem;
  color: #444;
  white-space: pre-wrap;
  line-height: 1.9;
}
</style>
